import { AxiosResponse } from 'axios';
import BaseService from './BaseService';
import BeneficiarioNoAfiliado from '@/models/BeneficiarioNoAfiliado';
import ConsultaFallecido, { ConsultaValidacionFallecimientoAll, ConsultaValidacionBeneficiarioResp } from "@/models/ConsultaFallecido";
import ServiceResponse from "@/services/response-models/ServiceResponse";
import {DashboardEntity, DashboardResponse} from "@/models/Dashboard/DashboardResponse";
import {DashboardTrimestralResponse} from "@/models/Dashboard/DashboardTrimestralResponse";
import {BeneficiosDisponiblesResponse} from "@/models/Dashboard/BeneficiosDisponiblesResponse";
import {VideoIntroResponse} from "@/models/Dashboard/VideoIntroResponse";
import {PhotoBeneficiarioResponse} from "@/models/Dashboard/PhotoBeneficiarioResponse";  
import ServiceResponseEntity from './response-models/ServiceResponseEntity';
import ServiceResponseSolicitud from './response-models/ServiceResponseSolicitud';
import ServiceResponseSolicitudes from './response-models/ServiceResponseSolicitudes';
import ServiceResponseArchivos from './response-models/ServiceResponseArchivos';
import ParametrosCatalogo from '@/models/ParametrosCatalogo';
import {AseguradoraCatalogoResponse,CatalogoResponse} from '@/models/CatalogoResponse';
import RegistroPresolicitud from '@/models/RegistroPresolicitud';
import RecuperacionClave from '@/models/RecuperacionClave';
import AfiliadoData from '@/models/AfiliadoData/AfiliadoData';
import CambioClave from '@/models/CambioClave';
import Banco from '@/models/Banco';
import FormaDePago from '@/models/FormaDePago';
import ServiceResponseEntities from './response-models/ServiceResponseEntities';
import FirmanteContratoIngresoTardio from '@/models/FirmanteContratoIngresoTardio';
import PackageResult from '@/models/PackageResult';
import ParametrosObtencionPresolicitud from '@/models/ParametrosObtencionPresolicitud';
import ModalidadRetiroITResponse,{ModalidadRetiroIT} from '@/models/ModalidadRetiroIT/ModalidadRetiroIT';
import ParamsGetSolicitud from '@/models/ParamsGetSolicitud';
import SolicitudBeneficio from '@/models/SolicitudBeneficio';
import ExistPreviousPreSolicitud from '@/models/Sobrevivencia/ExistPreviousPreSolicitud';
import Presolicitud from '@/models/Presolicitud';
import ApiResponse from './response-models/ApiResponse';
import ApiResponseTrimestral from './response-models/ApiResponseTrimestral';

export default class AfiliadoService extends BaseService<any> {
    public constructor() {
        super("Afiliado");
    }

    public async registroBeneficiarioNoAfiliado(beneficiarioNoAfiliado: BeneficiarioNoAfiliado): 
    Promise<AxiosResponse<ServiceResponse>> {
        return this.post('RegistroBeneficiarioNoAfiliado', beneficiarioNoAfiliado);
    }

    public async consultarAfiliadoFallecido(consultaFallecido: ConsultaFallecido): 
    Promise<AxiosResponse<ServiceResponseEntity<ConsultaValidacionFallecimientoAll>>> {
        return this.post('ConsultarAfiliadoFallecido', consultaFallecido);
    }

    public async ObtenerSolicitudAfiliado(consultaFallecido: ConsultaFallecido): 
    Promise<AxiosResponse<ServiceResponseEntity<Presolicitud>>> {
        return this.post('ObtenerSolicitudAfiliado', consultaFallecido);
    }

    public async registroPresolicitud(registroPresolicitud: RegistroPresolicitud, documentos: { actaDefuncion: File[] } | { cedula: File[], referenciaDocumentoBancario: File[], docsActDatos: File[], documentosAdicionales: File[] } | { cedula: File[], actaNacimiento:File[],cartaAseguradora : File[], referenciaDocumentoBancario: File[], docsActDatos: File[], documentosAdicionales: File[] }): 
    Promise<AxiosResponse<ServiceResponseSolicitud>> {
        return this.post('RegistroPresolicitud', { registroPresolicitud }, documentos);
    }
    
    public async ciudades(term: string = null, parametrosCatalogo: ParametrosCatalogo = new ParametrosCatalogo()): 
    Promise<AxiosResponse<ServiceResponseEntity<Array<CatalogoResponse>>>> {
        let action: string = 'Ciudades';
        if (term) {
            action += `/${term}`;
        }
        return this.post(action, parametrosCatalogo);
    }

    public async sectores(term: string = null, parametrosCatalogo: ParametrosCatalogo = new ParametrosCatalogo()): 
    Promise<AxiosResponse<ServiceResponseEntity<Array<CatalogoResponse>>>> {
        let action: string = 'Sectores';
        if (term) {
            action += `/${term}`;
        }
        return this.post(action, parametrosCatalogo);
    }

    public async parentescos(term: string = null, parametrosCatalogo: ParametrosCatalogo = new ParametrosCatalogo()): 
    Promise<AxiosResponse<ServiceResponseEntity<Array<CatalogoResponse>>>> {
        let action: string = 'Parentescos';
        if (term) {
            action += `/${term}`;
        }
        return this.post(action, parametrosCatalogo);
    }
    public async parentescosSobrevivencia(term: string = null, parametrosCatalogo: ParametrosCatalogo = new ParametrosCatalogo()): 
    Promise<AxiosResponse<ServiceResponseEntity<Array<CatalogoResponse>>>> {
        let action: string = 'ParentescosSobrevivencia';
        if (term) {
            action += `/${term}`;
        }
        return this.post(action, parametrosCatalogo);
    }

    public async viasNotificacion(term: string = null, parametrosCatalogo: ParametrosCatalogo = new ParametrosCatalogo()): 
    Promise<AxiosResponse<ServiceResponseEntity<Array<CatalogoResponse>>>> {
        let action: string = 'ViasNotificacion';
        if (term) {
            action += `/${term}`;
        }
        return this.post(action, parametrosCatalogo);
    }
    
    public async aseguradoras(term: string = null): 
    Promise<AxiosResponse<ServiceResponseEntities<Array<AseguradoraCatalogoResponse>>>> {
        let action: string = 'Aseguradoras';
        if (term) {
            action += `/${term}`;
        }
        return this.post(action, null);
    }

    public async getPresolicitud(parametrosObtencionPresolicitud: ParametrosObtencionPresolicitud): 
    Promise<AxiosResponse<ServiceResponseSolicitudes>> {
        return this.post(`ObtenerPresolicitud`, parametrosObtencionPresolicitud);
    }

    public async getDocumentosPresolicitud(numeroSolicitud: number): 
    Promise<AxiosResponse<ServiceResponseArchivos>> {
        return this.post(`ObtenerDocumentosPresolicitud/${numeroSolicitud}`, null);
    }

    public async consultarBeneficiario(consultaFallecido: ConsultaFallecido): 
    Promise<AxiosResponse<ServiceResponseEntity<ConsultaValidacionBeneficiarioResp>>> {
        return this.post('ConsultarBeneficiario', consultaFallecido);
    }

    public async recuperarClave(recuperacionClave: RecuperacionClave):
    Promise<AxiosResponse<ServiceResponse>> {
        return this.post('RecuperarClave', recuperacionClave);
    }

    public async cambiarClave(cambioClave: CambioClave):
    Promise<AxiosResponse<ServiceResponse>> {
        return this.post('CambiarClave', cambioClave);
    }
    public async obtenerComision(data:any)
	{
		return this.post("ObtenerComision", data);
	}
    public async actualizarDatos(beneficiarioNoAfiliado: BeneficiarioNoAfiliado): 
    Promise<AxiosResponse<ServiceResponse>> {
        return this.post('ActualizarDatos', beneficiarioNoAfiliado);
    }

    public async bancos(term: string = null): 
    Promise<AxiosResponse<ServiceResponseEntities<Array<Banco>>>> {
        let action: string = 'Bancos';
        if (term) {
            action += `/${term}`;
        }
        return this.post(action, null);
    }

    public async metodosDePago(monto: number, term: string = null): 
    Promise<AxiosResponse<ServiceResponseEntities<Array<FormaDePago>>>> {
        let action: string = 'FormasDePago';
        if (term) {
            action += `/${term}`;
        }
        return this.post(action, { monto: monto});
    }
    public async metodosDePagoSobrevivencia(monto: number,tipoBeneficio:string,estado:string, term: string = null): 
    Promise<AxiosResponse<ServiceResponseEntities<Array<FormaDePago>>>> {
        let action: string = 'FormasDePago';
        if (term) {
            action += `/${term}`;
        }
        return this.post(action, { monto: monto,tipoBeneficio:tipoBeneficio,estado:estado});
    }
    
    public async tiposDeCuenta(term: string = null, parametrosCatalogo: ParametrosCatalogo = new ParametrosCatalogo()): 
    Promise<AxiosResponse<ServiceResponseEntity<Array<CatalogoResponse>>>> {
        let action: string = 'TiposDeCuenta';
        if (term) {
            action += `/${term}`;
        }
        return this.post(action, parametrosCatalogo);
    }

    public async firmarContratoIngresoTardio(firmanteContratoIngresoTardio: FirmanteContratoIngresoTardio): 
    Promise<AxiosResponse<PackageResult>> {
        return this.post('FirmarContratoIngresoTardio', firmanteContratoIngresoTardio);
    }

    public async getSolicitud(paramsGetSolicitud: ParamsGetSolicitud): 
    Promise<AxiosResponse<ServiceResponseEntity<SolicitudBeneficio>>> {
        return this.post(`ObtenerSolicitud`, paramsGetSolicitud);
    }

    public async getUserIpAddress(): Promise<AxiosResponse<{ ip: string }>> {
        return this.get('UserIpAddress');
    }

    public async getCurrentDate(): Promise<AxiosResponse<{ currentDate: string }>> {
        return this.get('CurrentDate');
        
    }
    public async firmarContratoCesantia(firmanteContratoIngresoTardio: FirmanteContratoIngresoTardio): 
    Promise<AxiosResponse<PackageResult>> {
        return this.post('FirmarContratoCesantia', firmanteContratoIngresoTardio);
    }
    public async firmarContratoVejezAnticipada(firmanteContratoIngresoTardio: FirmanteContratoIngresoTardio): 
    Promise<AxiosResponse<PackageResult>> {
        return this.post('FirmarContratoVejezAnticipada', firmanteContratoIngresoTardio);
    }
    public async tiposPension(term: string = null, parametrosCatalogo: ParametrosCatalogo = new ParametrosCatalogo()): 
    Promise<AxiosResponse<ServiceResponseEntity<Array<CatalogoResponse>>>> {
        let action: string = 'TiposPension';
        if (term) {
            action += `/${term}`;
        }
        return this.post(action, parametrosCatalogo);
    }
    public async getModalidadRetiroIT():  Promise<AxiosResponse<ServiceResponseEntity<Array<ModalidadRetiroIT>>>>{
        return this.post('GetModalidadRetiroIT', null);
    }
    public async getAfiliadoData(userIdentity:string): 
    Promise<AxiosResponse<AfiliadoData>> {
        let action: string = 'Dashboard';
        
        return this.post(action, {userIdentity:userIdentity});
    }

    public async registrarAsesoria(userIdentity:string): 
    Promise<AxiosResponse> {
        let action: string = 'RegistrarAsesoria';
        
        return this.post(action, {CodUsuario:userIdentity,IdMaestroNotificacion:'IT',Canal:'PortalBe'});
    }

    public async logOut(sessionId: string): 
    Promise<AxiosResponse<ServiceResponse>> {
        return this.post('Logout',sessionId);
    }
    public async getDashbord(userIdentity:string): 
    Promise<AxiosResponse<DashboardResponse>> {
        let action: string = 'Dashboard';
        
        return this.post(action, {userIdentity:userIdentity});
    }

    public async getDashboardNew(userIdentity: string, tokenUser: string, userIdentityEncrypt: string): 
    Promise<AxiosResponse<ApiResponse<DashboardEntity>>> {
 
    return this.post("DashboardNewApi",    {
        userIdentity: userIdentity,
        tokenUser: tokenUser,
        userIdentityEncrypt: userIdentityEncrypt
      });
  }

    public async getDashbordTrimestral(userIdentity: string, tokenUser: string, userIdentityEncrypt: string): 
    Promise<AxiosResponse<ApiResponseTrimestral<DashboardTrimestralResponse>>> {
        let action: string = 'DashboardTrimestral';
        
        return this.post(action, {userIdentity: userIdentity,
            tokenUser: tokenUser,
            userIdentityEncrypt: userIdentityEncrypt});
    }
    public async getBeneficiosDisponibles(userIdentity:string): 
    Promise<AxiosResponse<BeneficiosDisponiblesResponse>> {
        let action: string = 'ObtenerBeneficiosDisponibles';
        
        return this.post(action, {cedulaAfiliado:userIdentity});
    }

    public async getVideoIntro(userIdentity:string): 
    Promise<AxiosResponse<VideoIntroResponse>> {
        let action: string = 'ObtenerVideoIntro';
        
        return this.post(action, {cedulaAfiliado:userIdentity});
    }
    public async VideoIntroPost(userIdentity:string): 
    Promise<AxiosResponse<VideoIntroResponse>> {
        let action: string = 'VideoIntroPost';
        
        return this.post(action, {cedulaAfiliado:userIdentity,mostrarVideo:false});
    }

    public async GetPhotoBeneficiario(userIdentity: string, tokenUser: string, userIdentityEncrypt: string): 
    Promise<AxiosResponse<PhotoBeneficiarioResponse>> {
        let action: string = 'GetPhotoBeneficiario';
        
        return this.post(action, {userIdentity: userIdentity,
            tokenUser: tokenUser,
            userIdentityEncrypt: userIdentityEncrypt});
    }

    public async getExistPreviosPreSolicitud(consultaFallecido: ConsultaFallecido): 
    Promise<AxiosResponse<ExistPreviousPreSolicitud>> {
        return this.post('GetExistPreviosPreSolicitud', consultaFallecido);
    }

    public async convertPdfToImage(base64Pdf: string): Promise<AxiosResponse<{ images: string[] }>> {
        return this.post('ConvertPdfToImage', { base64Pdf });
    }
    
}